import React from "react"

export interface IconProps {
    name: string
}

export class Icon extends React.Component<IconProps, any> {
    render() {
        return <span className={`icon-${this.props.name}`} />
    }
}
